import api from '../config/api';

export const getProjectDetail = id => {
    const res = api.get(`/actions/${encodeURIComponent(id)}/`);
    return res;
};
